import { useMemo } from 'react';
import { useGetPersonalizationStrategyQuery } from 'personalization-lib/__generated__/chirp/com/hubspot/personalize/rpc/PersonalizeRpc.hooks';
import useFetchAssetsByIds from 'personalization-lib/hooks/useFetchAssetsByIds';
import { getAssetIds, strategyToVariants } from 'personalization-lib/utils/personalization';
/**
 * Returns the variants for a given strategy along with asset metadata.
 *
 * @param strategyId - The id of the strategy to fetch variants for.
 * @returns The variants for the given strategy.
 */
const useVariants = (strategyId, onError) => {
  var _data$personalization;
  const {
    data,
    loading: variantsLoading,
    error: variantsError
  } = useGetPersonalizationStrategyQuery({
    variables: {
      id: strategyId
    },
    skip: !strategyId,
    onError
  });
  const variants = useMemo(() => data ? strategyToVariants(data.personalizationStrategy) : [], [data]);

  // TODO: Remove the ? once asset coordinates migration work is finished
  const assetSource = data === null || data === void 0 || (_data$personalization = data.personalizationStrategy.assetCoordinates) === null || _data$personalization === void 0 ? void 0 : _data$personalization.source;
  const assetIds = useMemo(() => getAssetIds(variants), [variants]);
  const {
    assetsById,
    loading: assetsLoading,
    error: assetsError
  } = useFetchAssetsByIds(assetSource, assetIds, onError);
  const loading = variantsLoading || assetsLoading;
  const error = variantsError || assetsError;
  return useMemo(() => ({
    // TODO: Remove the ! once asset coordinates migration work is finished
    variants: variants.map(({
      assetCoordinates,
      segmentIdentifier
    }) => ({
      assetCoordinates: assetCoordinates,
      segmentIdentifier,
      assetData: assetsById === null || assetsById === void 0 ? void 0 : assetsById[assetCoordinates.id]
    })),
    loading,
    error
  }), [variants, assetsById, loading, error]);
};
export default useVariants;